import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareDefaultHeaders } from '../../api'

// Rooted at the feed server (not `/i/`) so a feature's public reads and `/i/` writes share one cache.
export const internalFeedApi = createApi({
  reducerPath: 'internalFeedApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.GR_API_URLS.API_URL_FEED + '/',
    prepareHeaders: prepareDefaultHeaders,
  }),
  endpoints: () => ({}),
})
